// src/store/authActions.js
import axios from '../api/axiosConfig';
import { login, logout, setLoading, restoreAuth } from './authSlice';
import { showSnackbar } from './snackbarSlice';

// Login action
export const loginUser = (email, password) => async (dispatch) => {
  try {
    const response = await axios.post('/auth/login', { email, password });

    if (response.data.success) {
      // Extract user data from the response (token is in HTTP-only cookie)
      const { user_id, tenant_id, roles, schema_name, first_name, last_name, role, email } =
        response.data;

      // Create user object for the store
      const user = {
        user_id,
        tenant_id,
        roles,
        schema_name,
        first_name,
        last_name,
        role,
        email,
      };

      dispatch(login(user));
      dispatch(showSnackbar({ message: 'Login successful!', severity: 'success' }));
      return true;
    } else {
      throw new Error(response.data.message || 'Login failed');
    }
  } catch (error) {
    dispatch(
      showSnackbar({ message: 'Login failed. Please check your credentials.', severity: 'error' })
    );
    console.error('Login failed', error);
    return false;
  }
};

// Restore authentication from stored token
export const restoreAuthFromToken = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));

    // Check if we have a temp token from registration
    const tempToken = localStorage.getItem('temp_token');
    if (tempToken) {
      // Try to validate the token and get user info
      const response = await axios.get('/auth/me', {
        headers: {
          Authorization: `Bearer ${tempToken}`,
        },
      });

      if (response.data.success) {
        const { user_id, tenant_id, roles, schema_name, first_name, last_name, role, email } =
          response.data;
        const user = {
          user_id,
          tenant_id,
          roles,
          schema_name,
          first_name,
          last_name,
          role,
          email,
        };

        dispatch(restoreAuth(user));
        localStorage.removeItem('temp_token'); // Clean up temp token
        return true;
      }
    }

    // Check if we have stored user data
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      dispatch(restoreAuth(user));
      return true;
    }

    return false;
  } catch (error) {
    console.error('Auth restoration failed:', error);
    // Clear invalid tokens
    localStorage.removeItem('temp_token');
    localStorage.removeItem('user');
    return false;
  } finally {
    dispatch(setLoading(false));
  }
};

// Logout action
export const logoutUser = () => async (dispatch) => {
  try {
    await axios.post('/auth/logout');
    dispatch(logout());
    dispatch(showSnackbar({ message: 'Logout successful!', severity: 'success' }));
  } catch (error) {
    dispatch(showSnackbar({ message: 'Logout failed. Please try again.', severity: 'error' }));
    console.error('Logout failed', error);
  }
};
